import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

import { Typography } from 'components/v2';

import AppointmentsListContainer from './AppointmentsListContainer';

const messages = defineMessages({
  emptyState: {
    id: 'modules.LumaBot.MessageAppointments.EmptyState.emptyState',
    defaultMessage: 'No upcoming appointments',
  },
});

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    margin: {
      margin: `${unit * 2}px 0`,
    },
  });

export interface EmptyStateProps extends WithStyles<typeof styles> {}

const EmptyState: React.FC<EmptyStateProps> = ({ classes }) => {
  const { formatMessage } = useIntl();

  return (
    <AppointmentsListContainer>
      <Typography align="center" color="boulder" variant="bW600F14" className={classes.margin}>
        {formatMessage(messages.emptyState)}
      </Typography>
    </AppointmentsListContainer>
  );
};

export default withStyles(styles, { name: 'EmptyState' })(EmptyState);
